const {
  createBrowserHistory: _createBrowserHistory,
  createHashHistory: _createHashHistory,
  createMemoryHistory: _createMemoryHistory,
} = require('history');
const qs = require('qs');

/**
 * Umi3-compatible history:
 * - location always has `.query` (parsed from search)
 * - push/replace accept `{ pathname, query }` and stringify query → search
 */
function enrichLocation(location) {
  if (!location) return location;
  location.query = qs.parse((location.search || '').replace(/^\?/, '')) || {};
  return location;
}

function normalizeTo(to) {
  if (!to || typeof to === 'string') return to;
  if (!to.query || typeof to.query !== 'object') return to;
  const { query, search, ...rest } = to;
  // umi3: `query` wins over raw `search` when both present
  const nextSearch = qs.stringify(query);
  return {
    ...rest,
    search: nextSearch ? `?${nextSearch}` : '',
  };
}

function patchHistory(h) {
  enrichLocation(h.location);

  const rawListen = h.listen.bind(h);
  h.listen = (listener) =>
    rawListen((location, action) => {
      enrichLocation(location);
      if (h.location && h.location !== location) {
        enrichLocation(h.location);
      }
      listener(location, action);
    });

  const wrapNav = (fn) =>
    function patchedNav(to, state) {
      const ret = fn.call(this, normalizeTo(to), state);
      enrichLocation(h.location);
      return ret;
    };

  h.push = wrapNav(h.push.bind(h));
  h.replace = wrapNav(h.replace.bind(h));

  const wrapGo = (fn) =>
    function patchedGo(...args) {
      const ret = fn.apply(this, args);
      enrichLocation(h.location);
      return ret;
    };
  h.go = wrapGo(h.go.bind(h));
  h.goBack = wrapGo(h.goBack.bind(h));
  h.goForward = wrapGo(h.goForward.bind(h));

  return h;
}

function createBrowserHistory(options) {
  return patchHistory(_createBrowserHistory(options));
}
function createHashHistory(options) {
  return patchHistory(_createHashHistory(options));
}
function createMemoryHistory(options) {
  return patchHistory(_createMemoryHistory(options));
}

module.exports = {
  createBrowserHistory,
  createHashHistory,
  createMemoryHistory,
};
